import React from 'react';
import { FormattedMessage } from 'react-intl';

class AboutPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedMessage id={'about'} defaultMessage={'About'} tagName={'h4'} />
                    </div>
                </div>
            </div>
        );
    }
}

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/about/index.jsx